import './BlockedBrowserWarning.scss';

import React from 'react';
import { getChromeDownloadUrl, getEdgeDownloadUrl } from '../../utils/browserDetector';
import guideImage from '../../img/guide.png';
import splash0Image from '../../img/splash0.png';
import { useTranslation } from 'react-i18next';

interface IBlockedBrowserWarningProps {
  browserName: string;
  isMobile: boolean;
}

/**
 * 被禁止的浏览器警告页面
 * 完全阻止用户访问，推荐下载兼容浏览器
 */
const BlockedBrowserWarning: React.FC<IBlockedBrowserWarningProps> = ({ browserName, isMobile }) => {
  const { t } = useTranslation();
  const chromeDownloadUrl = getChromeDownloadUrl(isMobile);
  const edgeDownloadUrl = getEdgeDownloadUrl();
  const isWeChatBrowser = browserName === 'WeChat';

  return (
    <div className='blocked-browser-container'>
      {
        (isWeChatBrowser && isMobile) &&
        <div className='blocked-browser-guide-overlay'>
          <img src={guideImage} alt='' className='guide-arrow' />
          <div className='guide-message'>{t('browserWarning.blocked.openInBrowser')}</div>
        </div>
      }
      <div className='blocked-browser-content'>
        <img src={splash0Image} alt='Logo' className='app-logo' />
        <h1 className='warning-title'>
          <span className='warning-icon'>⚠️</span>
          {t('browserWarning.blocked.title')}
        </h1>
        <p className='warning-message'>
          {t('browserWarning.blocked.message')}
          <br />
          {t('browserWarning.blocked.browserRecommendation')}
        </p>

        <div className='download-buttons'>
          <a href={chromeDownloadUrl} target='_blank' rel='noopener noreferrer' className='download-button'>
            {isMobile ? t('browserWarning.blocked.downloadButtonMobile') : t('browserWarning.blocked.downloadButton')}
          </a>
          <a href={edgeDownloadUrl} target='_blank' rel='noopener noreferrer' className='download-button'>
            {isMobile
              ? t('browserWarning.blocked.edgeDownloadButtonMobile')
              : t('browserWarning.blocked.edgeDownloadButton')}
          </a>
        </div>

        <p className='tip'>
          {isMobile ? t('browserWarning.blocked.tipMobile') : t('browserWarning.blocked.tipDesktop')}
          <br />
          {t('browserWarning.blocked.edgeRecommendationTip')}
        </p>
      </div>
    </div>
  );
};

export default BlockedBrowserWarning;
